/**
 * Intake Record — Domain Types
 *
 * Tracks the review lifecycle of Won opportunities through the intake queue.
 * Backed by the vba_salesquestionnaires Dataverse table.
 */

export type IntakeStatus = 'in-review' | 'linked' | 'dismissed';

/** Dataverse picklist values for vba_status */
export const INTAKE_STATUS_VALUES: Record<IntakeStatus, number> = {
  'in-review': 100_000_000,
  'linked':    100_000_001,
  'dismissed': 100_000_002,
};

export const INTAKE_STATUS_FROM_VALUE: Record<number, IntakeStatus> = {
  100_000_000: 'in-review',
  100_000_001: 'linked',
  100_000_002: 'dismissed',
};

export interface IntakeRecord {
  id: string;
  name: string;
  opportunityId: string;
  accountId: string;
  status: IntakeStatus;
  salesNotes?: string;
  primaryContact?: string;
  contactEmail?: string;
  createdOn?: string;
  modifiedOn?: string;
}

export interface IntakeRecordQueryParams {
  status?: IntakeStatus;
}
